import { vModelText as _vModelText, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPay && _ctx.onPay(...args)), ["prevent"])),
    class: "flex flex-col sm:flex-row"
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "sm:flex-grow w-full h-12 py-3 px-5 leading-relaxed text-input-color bg-input-bg bg-clip-padding border border-solid border-input-bg focus:form-border rounded-md shadow-none transition-colors",
      placeholder: "Ej: 8.164.251-3",
      onfocus: "this.placeholder = ''",
      onblur: "this.placeholder = 'Ej: 8.164.251-3'",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.taxId) = $event)),
      onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.taxIdOnKeyDown && _ctx.taxIdOnKeyDown(...args))),
      onPaste: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.taxIdOnPaste && _ctx.taxIdOnPaste(...args)), ["prevent"]))
    }, null, 544), [
      [_vModelText, _ctx.taxId]
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("button", {
      type: "submit",
      class: "sm:flex-grow-0 mt-3 sm:mt-0 sm:ml-3 w-full sm:w-44 h-12 py-3 px-8 font-semibold text-center align-middle select-none border-none shadow-button transition-colors duration-500 rounded-md cursor-pointer bg-base-color focus:form-border"
    }, " Buscar ", -1))
  ], 32))
}